/* @ngInject */
function currencySymbol(currencies) {
  return function (code) {
    const currencyObject = currencies.find(
      (currencyObject) => currencyObject.code === code
    );

    return currencyObject ? currencyObject.symbol : "";
  };
}

export default currencySymbol;
